var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parent"},[_c('center',[_c('img',{attrs:{"src":"https://veis-schoolerp.s3.ap-south-1.amazonaws.com/logo/404.jpg","alt":""}}),_c('br'),_c('v-btn',{staticClass:"button1",on:{"click":_vm.back}},[_vm._v(" Go Home")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }